import { UserRole } from "../data/userRole";
import { apiGetRequest, apiPostRequest } from "../utils/webrequests";

export async function getUsersRoles(): Promise<UserRole[]> {
    try {
        // Make an API GET request to fetch event info
        const data: UserRole[] | undefined = await apiGetRequest("GetUsersRoles", null);

        // Check if data is undefined or null
        if (!data) {
            throw new Error('No data received from API');
        }
        return data; // Return the fetched data
    } catch (error: any) {
        throw new Error('Error fetching User Roles: ' + error.message);
    }
}
export async function getRoles(): Promise<string[]> {
    try {
        // Make an API GET request to fetch event info
        const data: string[] | undefined = await apiGetRequest("GetRoles", null);

        // Check if data is undefined or null
        if (!data) {
            throw new Error('No data received from API');
        }
        return data; // Return the fetched data
    } catch (error: any) {
        throw new Error('Error fetching roles: ' + error.message);
    }
}

export async function updateUserRole(userRole: UserRole): Promise<UserRole> {
    try {
        // Make an API GET request to fetch event info
        const data: UserRole = await apiPostRequest("UpdateUserRole", userRole);

        // Check if data is undefined or null
        if (!data) {
            throw new Error('No data received from API');
        }
        return data; // Return the fetched data
    } catch (error: any) {
        throw new Error('Error updating user role: ' + error.message);
    }
}
export async function addUserRole(userRole: UserRole): Promise<UserRole> {
    try {
        // Make an API GET request to fetch event info
        const data: UserRole = await apiPostRequest("AddUserRole", userRole);

        // Check if data is undefined or null
        if (!data) {
            throw new Error('No data received from API');
        }
        return data; // Return the fetched data
    } catch (error: any) {
        throw new Error('Error adding user role: ' + error.message);
    }
}